<template>
	<div class="ReCRUDFields">
		<div>
			<template v-for="(optFieldPrint, objPrint_index) in value">
				<div v-if="typeof optFieldPrint.newFiled == 'undefined' || optFieldPrint.newFiled == false" class="d-flex align-items-center" :key="objPrint_index">
					<div class="description mb-1">
						<h4 class="mr-2 mb-0" v-if="optFieldPrint.name != 'HTML'">{{optFieldPrint.name}}: </h4>
						<h4 class="mr-2 mb-0" v-if="optFieldPrint.name == 'HTML'">Чеклист: </h4>
						<p class="mb-0 " v-html="optFieldPrint.elements[0].element_model"></p> 
						<!-- <div v-html="optFieldPrint.elements[0].element_model"></div> -->
					</div>
					<button class="btn no-border btn-icon btn-fab btn-primary btn-simple" @click="editField(objPrint_index)" v-if="optFieldPrint.name != 'HTML'"><i class="tim-icons icon-pencil"></i></button>
					<button class="btn no-border btn-icon btn-fab btn-danger btn-simple" @click="delField(objPrint_index,true)" v-if="optFieldPrint.name != 'HTML'"><i class="tim-icons icon-trash-simple"></i></button>
				</div>
			</template>
		</div>
		<template v-for="(optField, obj_index) in value">
		<div v-if="optField.newFiled == true" :key="obj_index" class="row cc-item justify-content-between">
			<div class="fieldset col">
				
				<el-select
					class="select-primary d-none"
					placeholder="Тип поля"
					v-model="optField.field_type"
					:disabled="true"
				>
					<el-option
						v-for="(el_opt, el_index) in masFieldTypes"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>

				<el-select
					class="select-primary mr-3 pl-1"
					placeholder="Имя поля"
					v-model="optField.name"
				>
					<el-option
						v-for="(el_opt, el_index) in masFieldNames"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>

				<!-- <div class="px-2 w-100"></div> -->
					<ReFormPrinterOptions :opt="optField" :isCollapseItem="true" :frmAllConfig="value"/>
				
			</div>

			<div class="btnGroup pr-2">
				<button class="btn btn-icon btn-simple btn-danger" @click="delField(obj_index)">
					<i class="tim-icons icon-trash-simple"></i>
				</button>
			</div>
		</div>
		</template>
		<button class="btn btn-simple btn-primary mr-2" @click="addField()">
			Добавить поле
		</button>
		<button class="btn btn-simple btn-success" @click="saveFields()">
			Сохранить
		</button>
	</div>
</template>

<script>
	import ReFormPrinterOptions from 'src/our_components/FormPrinter/ReFormPrinterOptions.vue';
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReCRUDFields',
		components: {
			ReFormPrinterOptions,
			[Option.name]: Option,
			[Select.name]: Select
		},
		props: {
			findId: {
				type: String,
				default: '',
			},
			value:  {
				type:Array,
				default: function(){return []}
			},
			obj_type: String,
			obj_id: [String, Number]
		},
		data () {
			return {
				ver: 1,
				masFieldTypes:[],
				masFieldNames:[],
				iOperCount:0,
				timerAllDone: null,
			}
		},
		computed: {

		},
		methods: {
			addField(obj={}){
				if(this.$GVO.isEmpty(obj)){
					obj = { //переписать название полей на поля из модели
						field_type: 'input',
						name: 'Комментарий',
						elements: [{
							elementGetParamMap: 'test_input',
							element_model: '',
							elementType: 'input',
							placeholder: 'Пиши в меня',
						}],
						newFiled: true
					}
				}
				this.value.push(obj);
			},
			delField(ind,bReal=false){
				if(bReal){
					this.$GVO.ApiCall('addons_fields.DEL',{flt:{id:this.value[ind].id}})
					.then((objApi) => {
						if(objApi.success==true){

						}
					}).catch(errorObjApi => {console.error(errorObjApi)});
				}
				this.value.splice(ind,1);
			},
			editField(ind){
				let obj = this.$GVO.unlinkObject(this.value[ind]);
				obj.newFiled = true;
				this.value.splice(ind,1);
				this.addField(obj);
			},
			saveFields(){
				for (let i = 0; i < this.value.length; i++) {
					this.iOperCount++;
					const element = this.value[i];
					if(typeof element.newFiled !== 'undefined' && element.elements[0].element_model!=''){
						if(typeof element.id == 'undefined'){
							this.$GVO.ApiCall('addons_fields.INS',{iData:{obj_type:this.obj_type,obj_id:this.obj_id,field_type:element.field_type,name:element.name,val:element.elements[0].element_model}})
							.then((objApi) => {
								if(objApi.success==true){
									this.iOperCount--;
									//this.$emit('change', true);
								}
							}).catch(errorObjApi => {console.error(errorObjApi)});
						}else{
							this.$GVO.ApiCall('addons_fields.UPD',{flt:{id:element.id},uData:{obj_type:this.obj_type,obj_id:this.obj_id,field_type:element.field_type,name:element.name,val:element.elements[0].element_model}})
							.then((objApi) => {
								if(objApi.success==true){
									this.iOperCount--;
									//this.$emit('change', true);
								}
							}).catch(errorObjApi => {console.error(errorObjApi)});
						}
					} else {
						this.iOperCount--;
						// console.log('saveFields else',element);
					}
				}
				this.timerAllDone = setInterval(() => {
					if(this.iOperCount <= 0){
						this.$emit('change', true);
						this.iOperCount = 0;
						clearTimeout(this.timerAllDone);
						this.timerAllDone = null;
					}
				}, 100);
			},
			// replaceHtml(element){
			// 	//return element.replaceAll('<br/>', '\n');
			// 	return element;
			// }
		},
		mounted(){
			if(typeof this.$GVO.cats.CAT_FORMFIELDS_TYPE == 'undefined'){
				this.$GVO.LoadCatPromise('CAT_FORMFIELDS_TYPE')
				.then((objApi) => {
					for (let i = 0; i < this.$GVO.cats.CAT_FORMFIELDS_TYPE.length; i++) {
						const element = this.$GVO.cats.CAT_FORMFIELDS_TYPE[i];
						if(element.act==1) this.masFieldTypes.push({'value':element.val,'label':element.descr});
					}
				})
				.catch(errorObjApi => {console.error(errorObjApi); });
			}else{
				for (let i = 0; i < this.$GVO.cats.CAT_FORMFIELDS_TYPE.length; i++) {
					const element = this.$GVO.cats.CAT_FORMFIELDS_TYPE[i];
					if(element.act==1) this.masFieldTypes.push({'value':element.val,'label':element.descr});
				}
			}

			if(typeof this.$GVO.cats.CAT_FORMFIELD_NAMES == 'undefined'){
				this.$GVO.LoadCatPromise('CAT_FORMFIELD_NAMES')
				.then((objApi) => {
					for (let i = 0; i < this.$GVO.cats.CAT_FORMFIELD_NAMES.length; i++) {
						const element = this.$GVO.cats.CAT_FORMFIELD_NAMES[i];
						if(element.act==1) this.masFieldNames.push({'value':element.val,'label':element.name}); //вопрос val или id ?
					}
				})
				.catch(errorObjApi => {console.error(errorObjApi); });
			}else{
				for (let i = 0; i < this.$GVO.cats.CAT_FORMFIELD_NAMES.length; i++) {
					const element = this.$GVO.cats.CAT_FORMFIELD_NAMES[i];
					if(element.act==1) this.masFieldNames.push({'value':element.val,'label':element.name}); //вопрос val или id ?
				}
			}
			
		}
	}
</script>
<style scoped>
	.ReCRUDFields >>>  .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: row;
	}
	.ReCRUDFields >>>  .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
		display: flex;
	}
	.ReCRUDFields >>> .cc-item{
		margin-bottom: 15px;
	}
	.ReCRUDFields >>> .form-options-group .row, .ReCRUDFields >>> .form-options-group .form-group {
		margin-bottom: 0;
	}
	.ReCRUDFields >>> .form-options-group{
		margin-right: 0;
		padding: 0px 10px;
	}
	.ReCRUDFields >>> .form-options-group .row > * {
		padding: 0px 8px;
	}
	.ReCRUDFields .description {display: flex; flex-wrap: wrap; align-items: baseline; width: 100%; border-bottom: 1px dashed #01B0E0;}
	.ReCRUDFields >>> .fieldset .el-select:first-child {margin-right: 8px;}
	/* .ReCRUDFields >>> .smth {white-space: pre-wrap;} */

	@media (max-width: 900px) {
		.ReCRUDFields >>>  .fieldset {flex-direction: column;}
		.ReCRUDFields >>>  .fieldset > * {margin-bottom: 5px;}
		.ReCRUDFields >>> .form-options-group .row > * {padding: 0px 12px 0px 0px;}
		.ReCRUDFields >>> .fieldset .el-select:first-child {margin-right: 0!important;}
		.ReCRUDFields >>> .btnGroup {
			display: flex;
			flex-direction: column;
			width: 100%;
			padding: 0 12px;
		}

		    
	
	}
</style>
